module.exports = __webpack_public_path__ + "static/sushiIcon-14f3f16f57ee9e5d68caa0204c709121.png";